import React, { FC } from "react";
import cn from "classnames";
import { ReactComponent as CalendarIcon } from "src/assets/icons/calendar.svg";

interface Props {
  className?: string;
  date: string;
}

export const Date: FC<Props> = ({ className, date }) => {
  return (
    <div className={cn("flex items-center gap-1", className)}>
      <CalendarIcon />
      <span className="text-purple-base text-sm md:text-lg">{date}</span>
    </div>
  );
};
